import { useEffect, useState } from "react";
import { useProblem } from "../../contexts/problem-context";
import fetchWrapper from "../../utils/fetch";
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Progress,
} from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth-context";
import { toast } from "react-toastify";

export default function AnswerQuestions() {
  const [problemContext, problemDispatch] = useProblem();
  const [{ user }] = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const goToFirstPair = () => {
    setIsLoading(true);
    problemDispatch({
      type: "undo question",
    });
    setIsLoading(false);
  };

  const goToPreviousPair = () => {
    setIsLoading(true);
    problemDispatch({
      type: "first question",
    });
    setIsLoading(false);
  };

  const submit = (n) => {
    setIsLoading(true);
    let operator;
    switch (n) {
      case 0:
        operator = "==";
        break;
      case 1:
        operator = ">=";
        break;
      case 2:
        operator = "<=";
        break;
      case 3:
        operator = "";
        break;
      default:
        toast.error("گزینه انتخاب شده صحیح نمی‌باشد.");
        return;
    }
    const up = [...problemContext.user_preferences];
    up.push(operator);
    const startTime = performance.now();
    fetchWrapper
      .post("/update/problem", {
        problem_uid: problemContext.uid,
        user_preferences: up,
        criteria_rates: problemContext.criteria_rates,
      })
      .then((data) => {
        const question_pairsss = [...problemContext.question_pairs];
        const endTime = performance.now();
        if (data.status === "decision_making") {
          question_pairsss.push(data.question_pairs);
          problemDispatch({
            type: "update problem",
            payload: {
              progress: data.progress,
              question_pairs: question_pairsss,
              user_preferences: up,
            },
          });
        } else {
          problemDispatch({
            type: "finished problem",
            payload: {
              progress: 100,
              answers: up,
              accuracy: data.accuracy,
            },
          });
          navigate(`/problem/result?problem_id=${problemContext.uid}`);
        }
        console.log(`Request Took ${endTime - startTime} miliseconds`);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error(err);
        setIsLoading(false);
      });
  };

  const question_pair =
    problemContext.question_pairs[problemContext.question_pairs.length - 1];

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="text-center space-y-6 mb-12">
        <h3 className="text-2xl md:text-3xl font-bold text-gray-800">
          لطفا به سوالات مقایسه ای زیر پاسخ دهید
        </h3>
        <h4 className="text-lg md:text-xl text-gray-600 font-medium">
          کدام گزینه از نظر شما مطلوب تر است؟
        </h4>
      </div>

      <div className="flex justify-end mb-6">
        <Popover placement="left" color="primary">
          <PopoverTrigger>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6 text-gray-500 hover:text-gray-700 transition-colors cursor-help"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
              />
            </svg>
          </PopoverTrigger>
          <PopoverContent>
            <div className="px-3 py-2">
              <div className="text-sm font-medium text-white leading-relaxed">
                در صورتی که سوال از نظر شما منطقی نیست، می‌توانید به آن پاسخ
                ندهید.
              </div>
            </div>
          </PopoverContent>
        </Popover>
      </div>

      <div className="mb-10 grid sm:grid-cols-2 grid-cols-1 gap-6">
        <div className="flex flex-row w-full gap-4 md:justify-start justify-center">
          <Button
            color="warning"
            variant="solid"
            className="max-w-sm mt-4 font-medium text-base bg-amber-500 hover:bg-amber-600 text-white shadow-sm hover:shadow transition-all"
            onClick={() => submit(3)}
            isDisabled={isLoading}
          >
            رد کردن این سوال
          </Button>
        </div>
        <div className="flex flex-row w-full gap-4 md:justify-end justify-center">
          <Button
            color="danger"
            variant="solid"
            className="max-w-sm mt-4 font-bold text-sm bg-red-500 hover:bg-red-600 text-white"
            onClick={() => goToFirstPair()}
            isDisabled={isLoading || problemContext.question_pairs.length === 1}
          >
            بازگشت به سوال قبلی
          </Button>
          <Button
            color="danger"
            variant="solid"
            className="max-w-sm mt-4 font-bold text-sm bg-red-500 hover:bg-red-600 text-white"
            onClick={() => goToPreviousPair()}
            isDisabled={isLoading || problemContext.question_pairs.length === 1}
          >
            بازگشت به اولین سوال
          </Button>
        </div>
      </div>
      <div className="w-full grid grid-cols-2 gap-8 my-10">
        <div className="col-span-1">
          <div 
            onClick={() => !isLoading && submit(1)}
            className={`cursor-pointer ${isLoading ? 'opacity-50' : 'hover:scale-[1.02]'} transition-all duration-200`}
          >
            <div className="rounded-xl border-2 border-gray-200 bg-white shadow-md py-8 px-6 text-center min-h-[220px] flex flex-col justify-center hover:border-blue-200 hover:shadow-lg transition-all duration-200">
              <div className="space-y-6">
                <div className="flex flex-col items-center space-y-4">
                  <div className="flex flex-col items-center gap-1 w-full">
                    <span className="font-bold text-gray-900 text-lg md:text-xl">
                      {question_pair[0][0].split("_")[0]}
                    </span>
                    <span
                      className="text-gray-800 text-lg md:text-xl break-words w-full"
                      dir="auto"
                    >
                      {question_pair[0][0].split("_")[1]}
                    </span>
                  </div>
                  <span className="text-gray-500 text-base">و</span>
                  <div className="flex flex-col items-center gap-1 w-full">
                    <span className="font-bold text-gray-900 text-lg md:text-xl">
                      {question_pair[0][1].split("_")[0]}
                    </span>
                    <span
                      className="text-gray-800 text-lg md:text-xl break-words w-full"
                      dir="auto"
                    >
                      {question_pair[0][1].split("_")[1]}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full mt-6 h-14 rounded-lg bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg transition-all flex items-center justify-center">
              <span className="text-lg font-semibold">این گزینه</span>
            </div>
          </div>
        </div>
        <div className="col-span-1">
          <div 
            onClick={() => !isLoading && submit(2)}
            className={`cursor-pointer ${isLoading ? 'opacity-50' : 'hover:scale-[1.02]'} transition-all duration-200`}
          >
            <div className="rounded-xl border-2 border-gray-200 bg-white shadow-md py-8 px-6 text-center min-h-[220px] flex flex-col justify-center hover:border-purple-200 hover:shadow-lg transition-all duration-200">
              <div className="space-y-6">
                <div className="flex flex-col items-center space-y-4">
                  <div className="flex flex-col items-center gap-1 w-full">
                    <span className="font-bold text-gray-900 text-lg md:text-xl">
                      {question_pair[1][0].split("_")[0]}
                    </span>
                    <span
                      className="text-gray-800 text-lg md:text-xl break-words w-full"
                      dir="auto"
                    >
                      {question_pair[1][0].split("_")[1]}
                    </span>
                  </div>
                  <span className="text-gray-500 text-base">و</span>
                  <div className="flex flex-col items-center gap-1 w-full">
                    <span className="font-bold text-gray-900 text-lg md:text-xl">
                      {question_pair[1][1].split("_")[0]}
                    </span>
                    <span
                      className="text-gray-800 text-lg md:text-xl break-words w-full"
                      dir="auto"
                    >
                      {question_pair[1][1].split("_")[1]}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full mt-6 h-14 rounded-lg bg-purple-600 hover:bg-purple-700 text-white shadow-md hover:shadow-lg transition-all flex items-center justify-center">
              <span className="text-lg font-semibold">این گزینه</span>
            </div>
          </div>
        </div>
      </div>
      <div className="grid justify-center">
        <Button
          color="success"
          variant="solid"
          className="w-full mt-8 font-bold text-xl px-12 py-8 bg-green-600 hover:bg-green-700 text-white shadow-md hover:shadow-lg transition-all rounded-xl"
          onClick={() => submit(0)}
          isLoading={isLoading}
          isDisabled={isLoading}
        >
          دو گزینه برابر هستند
        </Button>
      </div>

      <div className="grid mt-16 text-center">
        <h2 className="text-xl font-bold mb-6 text-gray-800">میزان پیشرفت</h2>
        <Progress
          aria-label="رسیدن به پاسخ"
          size="lg"
          value={Math.floor(
            problemContext.progress[problemContext.progress.length - 1],
          )}
          color="success"
          showValueLabel={true}
          className="max-w-md w-full mx-auto"
        />
      </div>

      {user.is_admin && (
        <div className="mt-8 flex justify-center">
          <Button
            color="danger"
            variant="solid"
            className="max-w-sm font-medium text-base bg-red-600 hover:bg-red-700 text-white shadow-sm hover:shadow transition-all h-12"
            onClick={() => navigate("/")}
            isDisabled={isLoading}
          >
            عدم پاسخ به سوالات (مخصوص ادمین)
          </Button>
        </div>
      )}
    </div>
  );
}
